import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { IContactFlag } from 'clickNgo/entities/contactFlag'
import { ProfilingCodeType } from 'clickNgo/entities/profilingCode'
import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { IContactFlagsAllDataView } from 'clickNgo/models/crud/views'
import { IDataProviderFilter, IFilter, Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'
import Logger from 'core/utils/Logger'

import { mapContactFlagFromContactFlagsAllData } from './mapping/mapContactFlagFromContactFlagsAllData'

interface IFetchAllContactFlagsParams {
  contactId?: string
  partnerId?: string
  topPartnerId?: string
  type?: ProfilingCodeType
}

export const fetchAllContactFlags = async (
  params: IFetchAllContactFlagsParams,
  options?: ICrudFetchOptions
): Promise<IContactFlag[]> => {
  const { contactId, partnerId, topPartnerId, type } = params

  const source = CrudStore.get<IContactFlagsAllDataView>(
    CrudStoreItem.ContactFlagsAllData,
    options?.cacheKey
  )

  const isToolsType = type === ProfilingCodeType.Tools

  const filterByType: IFilter = {
    field: 'Type',
    operator: Operator.EQUAL,
    value: type ?? '',
  }

  const filterByContactId: IFilter = {
    field: 'ContactId',
    operator: Operator.EQUAL,
    value: contactId ?? '',
  }

  const filterByPartnerId: IFilter = {
    field: isToolsType ? 'TopPartnerId' : 'PartnerId',
    operator: Operator.EQUAL,
    value: partnerId ?? '',
  }

  const filterByTopPartnerId: IFilter = {
    field: 'TopPartnerId',
    operator: Operator.EQUAL,
    value: topPartnerId ?? '',
  }

  const filters: IDataProviderFilter = {
    logic: Logic.AND,
    filters: [filterByContactId, filterByPartnerId, filterByTopPartnerId, filterByType].filter(
      ({ value }) => value
    ),
  }

  source.setDefaultFilter(filters)

  if (options?.paging) {
    source.setPaging(options.paging)
  }

  if (options?.sort) {
    source.setSort(options.sort)
  }

  return source
    .fetch({
      skipHierarchyFilter: options?.skipHierarchyFilter,
      force: options?.isForce,
      skipTotal: options?.skipTotal,
    })
    .then(({ items }) => {
      if (items) {
        return items.map(mapContactFlagFromContactFlagsAllData)
      }

      return []
    })
    .catch((error) => {
      Logger.error(error)
      return []
    })
}
